import axios from 'axios';

const api = axios.create({
  // FIX: Using relative URL so Apache ProxyPass handles the HTTPS domain routing automatically
  baseURL: '/api/v1',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Auto-attach JWT Token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auto-Logout if idle for 30 mins (Token Expiration)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // CRITICAL FIX: Only redirect to login if NOT already on login page
      // This prevents the infinite loop and blank screen issue
      if (!window.location.pathname.includes('/login')) {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('emp_id');
        window.location.href = '/login';
      } else {
        // If already on login page, just reject the promise without redirecting
        // This allows the error message to show without page reload
        return Promise.reject(error);
      }
    }
    return Promise.reject(error);
  }
);

export default api;